import React from "react";
import Header from "../../component/Header";
import { Outlet } from "react-router-dom";

const LayoutFront = () => {
  return (
    <>
      <Header />
      <main>
        <Outlet />
      </main>
    </>
  );
};

export default LayoutFront;
